import { Inject, Injectable, SimpleChanges } from '@angular/core';

import { logger } from '@assess/shared/logger';

import { IPendoUser } from './pendo-user.interface';
import { PendoConfig } from './pendo.config';
import { pendoToken } from './pendo.token';

@Injectable()
export class PendoService {
  private readonly instanceLogger = logger.child({ context: PendoService.name });

  constructor(
    private readonly config: PendoConfig,
    @Inject(pendoToken) private readonly pendoInstance: typeof pendo | undefined
  ) {
    if (!pendoInstance) {
      this.instanceLogger.warn('pendo is undefined');
    }
  }

  initializePendo(user: IPendoUser) {
    this.instanceLogger.debug(PendoService.prototype.initializePendo.name);

    if (!this.config.enabled) {
      this.instanceLogger.warn('Pendo is disabled via configuration');

      return;
    }

    if (user && this.pendoInstance) {
      this.pendoInstance.initialize({
        visitor: {
          id: user.auth0Id as string,
          email: user.userEmail as string,
          full_name: [user.userLastName, user.userFirstName]
            .filter(Boolean)
            .map(String)
            .map((name) => name.trim())
            .join(', '),
          assess_version: this.config.appVersion,
        },
        account: {
          id: this.config.pendoId,
          environment: this.config.pendoEnvironment,
        },
        excludeAllText: true, // PLEASE DO NOT CHANGE
      });
    } else {
      this.instanceLogger.warn('Attempted to initialize Pendo without user data');
    }
  }

  toPendoUser(changes: SimpleChanges): IPendoUser {
    return {
      auth0Id: changes?.auth0Id?.currentValue,
      userEmail: changes?.userEmail?.currentValue,
      userId: changes?.userId?.currentValue,
      userFirstName: changes?.userFirstName?.currentValue,
      userLastName: changes?.userLastName?.currentValue,
    };
  }
}
